var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-params"},[_c('DynamicParamsDispatcher',{attrs:{"interfaceFieldUUID":_vm.widgetFieldUUID,"action":_vm.action,"service":_vm.service,"params":_vm.params},on:{"send-params-map":_vm.onParamsMapChange,"send-params-map-labels":_vm.onParamsMapLabelsChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }